module.exports = __webpack_public_path__ + "img/intelligent_icu.fc2a8f3b.jpg";